import { render, staticRenderFns } from "./AddOrUpdateForm.vue?vue&type=template&id=469c0b7d&"
import script from "./AddOrUpdateForm.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports